// extracted by mini-css-extract-plugin
export var mouse = "styles-module--mouse--36f8q";
export var scroll = "styles-module--scroll--AZPTc";
export var scrollDown = "styles-module--scrollDown--MgLin";
export var scroller = "styles-module--scroller--HdTrJ";